import { createSubsetSelector } from 'webui/utils/selectors';
export const legacy_guard_controls_config = createSubsetSelector(['id', 'siren', 'guard_state']);
export const legacy_guard_controls_state = createSubsetSelector([
    'siren',
    'guard_state',
    'siren__loading',
    'last_guard_event',
    'guard_state__loading',
    'siren__fail',
    'guard_state__fail',
    'action_fail_message',
]);
